// extracted by mini-css-extract-plugin
module.exports = {"InstantProtection":"InstantProtection_InstantProtection__pBkPa"};